import {
  AdsContextProps,
  useAds,
} from "@magalu/ecomm-components/contexts/AdsContext";
import { isEmpty } from "@magalu/ecomm-components/utils";
import { useEffect } from "react";

interface AdsResolverProps {
  data: AdsContextProps["data"];
}

const AdsResolver = ({ data }: AdsResolverProps) => {
  const { banners, showcases, fetchContextAds, status } = useAds();
  useEffect(() => {
    if (
      isEmpty(banners) &&
      isEmpty(showcases) &&
      !isEmpty(data?.ads) &&
      status !== "loading" &&
      fetchContextAds
    ) {
      fetchContextAds({ data });
    }
  }, []);
  return null;
};

export default AdsResolver;
